<template>
  <!-- Bottom Hero Banner Section -->
  <header class="relative">
    <UiArticleImage :fit="'crop'" :modifiers="modifiers" v-if="article.image" :article="article" />
    <UiContentwrapper class="absolute justify-center items-center inset-0">
      <UiNarrowColumnRight>
        <h2 v-if="!isSmallScreen" class="m-0 text-white mb-8" v-html="article.content"></h2>
        <h4 v-else class="m-0 text-white mb-0" v-html="article.content"></h4>
        <NuxtLink :to="extractLink(article.excerpthtml)">
          <UiRippleButton v-if="article.excerpt" class="white">
            {{ article.excerpt }}
          </UiRippleButton>
        </NuxtLink>
      </UiNarrowColumnRight>
    </UiContentwrapper>
  </header>
  <!-- Display the content under the image -->
  <UiExtraNarrowContent v-if="article.content">
  </UiExtraNarrowContent>
</template>

<script setup>
import { computed } from 'vue';
import { useBlogStore } from '@/stores/blogStore';
import { useWindowSize } from '@vueuse/core';

const UiRippleButton = defineAsyncComponent(() => import('@/components/ui/RippleButton.vue'));
const blogStore = useBlogStore();

const modifiers = computed(() => {
  if (blogStore.articleHasTag(props.article, 'Tall')) {
    return { auto: 'format,compress', ar: '1440:600' };
  } else {
    return { auto: 'format,compress', ar: '1440:600' };
  }
});

// Props
const props = defineProps({
  article: {
    type: Object,
    required: true,
  },
});



const extractLink = (excerpt) => {
  const linkMatch = excerpt.match(/href="([^"]*)"/);
  return linkMatch ? linkMatch[1] : '#';
};

// Detect screen size
const { width } = useWindowSize();
const isSmallScreen = computed(() => width.value < 350);
</script>